import fr from '../JsonLang/fr.json'
export const lang = { ...fr }